import { render } from "./IconItemCategoryDaily.vue?vue&type=template&id=00db77d2"
import script from "./IconItemCategoryDaily.vue?vue&type=script&lang=js"
export * from "./IconItemCategoryDaily.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__